














































































































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "@/plugins";

export default Vue.extend({
  name: "Edit",
  props: {
    projectId: { type: String }
  },
  data() {
    return {
      dialog: false,
      isEdit: false,
      loading: false,
      isEbs: false,
      ruleForm: {
        capacity: 20,
        description: "",
        name: "",
        storageClass: "",
        storageReadModel: ""
      },
      marks: {
        0: "0",
        512: "512Gi",
        1024: "1024Gi",
        1536: "1536Gi",
        2048: "2048Gi"
      },
      storageClassOptions: new Array<{ name: string }>()
    };
  },
  computed: {
    rules: function() {
      if (this.isEdit) {
        return {};
      } else {
        return {
          name: [{ required: true, type: "string", pattern: /^[a-z0-9-]+$/ }],
          description: [{ required: true, type: "string" }],
          storageReadModel: [
            { required: true, type: "string", trigger: "change" }
          ],
          storageClass: [{ required: true, type: "string", trigger: "change" }]
        };
      }
    }
  },
  methods: {
    getStorageClassOptions() {
      this.loading = true;
      axios.get(`/storage/storageclass/${this.projectId}`).then(res => {
        this.loading = false;
        this.storageClassOptions = res.data.data;
      });
    },
    show(data?: any) {
      this.getStorageClassOptions();
      if (data) {
        // 编辑模式
        this.ruleForm.name = data.metadata.name;
        this.ruleForm.description =
          data.metadata.annotations?.["appmgr.object.description"];
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.dialog = true;
    },
    classChange(val: string) {
      const data: any = this.storageClassOptions.find(
        item => item.name === val
      );
      if (/^ebs/g.test(data.provisioner)) {
        this.isEbs = true;
        this.ruleForm.storageReadModel = "";
      } else {
        this.isEbs = false;
      }
    },
    quit() {
      this.ruleForm = (this as any).$options.data().ruleForm;
      this.isEbs = false;
      this.storageClassOptions = (this as any).$options.data().storageClassOptions;
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
        this.dialog = false;
      });
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          this.loading = true;
          if (this.isEdit) {
            this.edit();
          } else {
            this.create();
          }
        }
      });
    },
    edit() {
      axios
        .put(
          `/storage/pvc/${this.projectId}/?name=${this.ruleForm.name}&desctiption=${this.ruleForm.description}`
        )
        .then(() => {
          this.$message.success("存储信息修改成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      axios
        .post(
          "/storage/pvc",
          Object.assign({}, this.ruleForm, { projectId: this.projectId })
        )
        .then(() => {
          this.$message.success("创建成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
